module.exports = __webpack_public_path__ + "static/media/contextual-highlight.4cdba930.gif";